var path = '/user/user-profile/user-profile.html';
var html = "<user-details-tabs></user-details-tabs> <md-card class=\"card-user-account profile\" user-can=view_profile> <md-card-content layout-padding> <article ng-include=\"'/user/user-profile/_form.html'\" class=md-block></article> </md-card-content> </md-card> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./user/user-profile/user-profile.html
// module id = 123
// module chunks = 0